var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDuckhuntCap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M504.565 3H8V328.174M504.565 3V328.174H8M504.565 3L521 19.4348V344.608H24.4348L8 328.174",
    stroke: "#FFC700",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 328.5L24.6 344.61L521 344.608L504.565 328.174L9 328.5Z",
    fill: "#E19400"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M521 344.608V19.4348L504.565 3V328.174L521 344.608Z",
    fill: "#FFC700"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M215.493 246.05C189.377 212.251 199.697 175.636 208.121 161.554C206.678 159.014 205.392 156.549 204.255 154.16C193.289 144.857 192.435 128.456 193.379 121.418C208.301 67.3138 313.426 92.9003 261.827 166.835C271.936 160.92 293.418 164.37 302.896 166.835C308.793 150.78 322.904 140.429 336.593 138.317C369.238 173.172 353.442 222.813 342.911 241.825C315.532 254.499 280.782 271.398 215.493 246.05Z",
    fill: "#FFC700"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M154.257 121.256H183.759C183.759 121.256 178.724 142.796 194.556 154.873C151.379 157.166 154.257 121.256 154.257 121.256Z",
    fill: "#FFC700"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 368V345H521.426V0H544.5V368H0Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuckhuntCap);
export default __webpack_public_path__ + "static/media/duckhunt-cap.0e06cc5c883f2994f473b1ac3dbcdcb4.svg";
export { ForwardRef as ReactComponent };